/* ============================================================
   FABLE v3 – Talas Akademija landing engine
   Zero dependencies, mobile-first, THEME-EDITOR-SAFE.

   The Shopify customizer re-renders section HTML via AJAX on
   every setting change, so this engine is built around two rules:
   1. Anything that binds to elements is an idempotent init(scope)
      that re-runs on `shopify:section:load`.
   2. Anything interactive uses DELEGATED document-level handlers
      that survive any re-render (FAQ, modal, newsletter, CTA).
   No entrance animations: content renders as-is, in the editor too.
   ============================================================ */
(function () {
  'use strict';

  var doc = document;
  var qs = function (s, c) { return (c || doc).querySelector(s); };
  var qsa = function (s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); };
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var CFG = window.__TALAS || {};
  var raf = window.requestAnimationFrame.bind(window);
  var DESIGN = !!(window.Shopify && window.Shopify.designMode);

  if (DESIGN) doc.documentElement.classList.add('design-mode');
  /* Response: iOS Safari only applies :active on touch-DOWN when a touch
     listener exists, so presses light up the instant a finger lands. */
  doc.addEventListener('touchstart', function () {}, { passive: true });

  /* Ref-counted body scroll lock so overlapping overlays (mobile menu +
     video modal) don't unlock each other. Each opener adds a key, each
     closer removes it; scroll is locked while any key is held. */
  var scrollLocks = {};
  function lockScroll(key, on) {
    if (on) scrollLocks[key] = 1; else delete scrollLocks[key];
    var any = false;
    for (var k in scrollLocks) { if (scrollLocks.hasOwnProperty(k)) { any = true; break; } }
    doc.documentElement.style.overflow = any ? 'hidden' : '';
  }

  var fmt = function (n) {
    try { return Number(n).toLocaleString('sr-RS'); } catch (e) { return String(n); }
  };

  /* Shared state that must survive section re-renders */
  var LIVE = null;            /* cached worker stats */
  var stickyObservers = [];   /* IOs to dispose on re-init */

  /* ============================================================
     A. Scoped, re-runnable initializers
     ============================================================ */

  /* --- counters ------------------------------------------------ */
  var counterIO = null;
  function animateCount(el, to) {
    var dur = 0; /* no count-up: the number is the content */
    var start = null;
    el.classList.add('tnum');
    /* Read the target from a live property each frame, so a Skool
       worker response landing mid-animation (applyLive updates __countTo)
       redirects the count-up to the fresh value instead of being
       overwritten back to the stale fallback. */
    el.__countTo = to;
    if (!dur) { el.textContent = fmt(el.__countTo); return; }
    function step(now) {
      if (!start) start = now;
      var p = clamp((now - start) / dur, 0, 1);
      var e = 1 - Math.pow(1 - p, 4);
      el.textContent = fmt(Math.round(el.__countTo * e));
      if (p < 1 && el.isConnected) raf(step);
    }
    raf(step);
  }
  function runCounter(el) {
    if (el.__counted) return;
    el.__counted = true;
    animateCount(el, parseInt(el.getAttribute('data-count-to'), 10) || 0);
  }
  function counters(scope) {
    var els = qsa('[data-count-to]', scope);
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || DESIGN) { els.forEach(runCounter); return; }
    if (!counterIO) {
      counterIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { runCounter(en.target); counterIO.unobserve(en.target); }
        });
      }, { threshold: 0.4 });
    }
    els.forEach(function (el) {
      if (el.__cio) return;
      el.__cio = true;
      counterIO.observe(el);
    });
  }

  /* --- live Skool stats ---------------------------------------- */
  function applyLive(scope) {
    if (!LIVE) return;
    var d = LIVE;
    var set = function (el, val) {
      if (el.hasAttribute('data-count-to')) {
        el.setAttribute('data-count-to', val);
        el.__countTo = val;                     /* redirect any in-flight count-up */
        if (el.__counted) el.textContent = fmt(val);
      } else {
        el.textContent = fmt(val);
      }
    };
    if (d.members) {
      qsa('[data-live="members"]', scope).forEach(function (el) { set(el, d.members); });
      /* "1.300+" – rounded down to the hundred, so the "+" stays true */
      qsa('[data-live="members-round"]', scope).forEach(function (el) {
        el.textContent = fmt(Math.floor(d.members / 100) * 100);
      });
    }
    if (d.online) {
      qsa('[data-live="online"]', scope).forEach(function (el) { set(el, d.online); });
      qsa('[data-live-online]', scope).forEach(function (el) {
        el.hidden = false;
        var n = qs('[data-live-online-num]', el);
        if (n) n.textContent = fmt(d.online);
      });
    }
    if (d.posts) qsa('[data-live="posts"]', scope).forEach(function (el) { set(el, d.posts); });
  }
  /* Live "online" is worker-only data with no honest static fallback.
     If it never arrives, hide the optional bits and blank the "···"
     placeholders so nothing sticks forever. Members/posts already have
     numeric fallbacks via data-count-to, so those are unaffected. */
  function onlineUnavailable() {
    if (LIVE && LIVE.online) return;
    qsa('[data-live-optional]').forEach(function (host) {
      var cell = qs('[data-live="online"]', host) || host;
      if (cell && cell.textContent.indexOf('·') !== -1) host.hidden = true;
    });
    qsa('[data-live="online"]').forEach(function (el) {
      if (el.textContent.indexOf('·') !== -1) el.textContent = '–';
    });
  }
  function fetchLive() {
    if (!CFG.worker) { onlineUnavailable(); return; }
    var settled = false;
    fetch(CFG.worker + '/?community=' + encodeURIComponent(CFG.community || 'talasakademija'))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        settled = true;
        if (!d || !d.members) { onlineUnavailable(); return; }
        LIVE = d;
        applyLive(doc);
        if (!d.online) onlineUnavailable();
      })
      .catch(function () { settled = true; onlineUnavailable(); });
    /* network-hang guard: don't leave "···" spinning past 8s */
    setTimeout(function () { if (!settled) onlineUnavailable(); }, 8000);
  }

  /* --- wins feed ------------------------------------------------ */
  function wins(scope) {
    var sec = qs('[data-wins]', scope) || (scope !== doc && scope.hasAttribute && scope.hasAttribute('data-wins') ? scope : null);
    if (!sec) {
      var inner = scope !== doc ? qs('[data-wins]', scope) : null;
      if (!inner) return;
      sec = inner;
    }
    if (sec.__init) return;
    sec.__init = true;
    var grid = qs('.wins__grid', sec);
    var moreBtn = qs('[data-wins-more]', sec);
    var totalEl = qs('[data-wins-total]', sec);
    if (!CFG.worker || !grid) {
      sec.style.display = 'none';
      return;
    }
    var page = 1, total = 0, shown = 0, busy = false;
    var batch = parseInt(sec.getAttribute('data-batch') || '12', 10);
    var buffer = [];

    function relTime(iso) {
      if (typeof iso !== 'string' || !iso) return '';
      var d = new Date(iso);
      var t = d.getTime();
      if (isNaN(t) || t <= 0) return '';
      var days = Math.floor((Date.now() - t) / 86400000);
      if (days <= 0) return 'danas';
      if (days === 1) return 'juče';
      if (days < 7) return 'pre ' + days + ' dana';
      if (days < 30) { var w = Math.floor(days / 7); return 'pre ' + w + (w === 1 ? ' nedelju' : w < 5 ? ' nedelje' : ' nedelja'); }
      if (days < 365) { var mo = Math.floor(days / 30); return 'pre ' + mo + (mo === 1 ? ' mesec' : mo < 5 ? ' meseca' : ' meseci'); }
      var y = Math.floor(days / 365); return 'pre ' + y + (y === 1 ? ' godinu' : y < 5 ? ' godine' : ' godina');
    }
    /* --- security helpers ---------------------------------------
       The #pobede feed is member-authored UGC relayed by a worker we
       treat as fully hostile. Cards are built with DOM APIs only –
       untrusted values reach the page via textContent / setAttribute,
       never an HTML parser – so tag- and attribute-injection are
       structurally impossible regardless of what the worker returns. */
    function safeImgUrl(u) {
      if (typeof u !== 'string' || !u) return '';
      var s = u.trim();
      /* allow only absolute http(s); blocks javascript:/data:/vbscript:/protocol-relative */
      if (!/^https?:\/\//i.test(s)) return '';
      try {
        var url = new URL(s);
        if (url.protocol !== 'http:' && url.protocol !== 'https:') return '';
        /* a member's Giphy reaction: the still frame is often black and says nothing about the win */
        if (/(^|\.)giphy\.com$/i.test(url.hostname)) return '';
        return url.href;
      } catch (e) { return '' ; }
    }
    function preconnect(href) {
      if (qs('link[rel="preconnect"][href="' + href + '"]')) return;
      var l = doc.createElement('link');
      l.rel = 'preconnect'; l.href = href;
      doc.head.appendChild(l);
    }
    function clampStr(v, max) {
      if (typeof v !== 'string') return '';
      /* strip control chars, collapse to a sane length */
      v = v.replace(/[\x00-\x08\x0b\x0c\x0e-\x1f\x7f]/g, '');
      return v.length > max ? v.slice(0, max) : v;
    }
    /* Skool's rich text arrives as markup: [ol:1][li]item, [ul][li]item, [label](https://…). A label may be cut off with its link. */
    function plainSkool(v) {
      if (typeof v !== 'string') return v;
      return v.replace(/\[(?:ol(?::\d+)?|ul)\]/g, '')
        .replace(/\s*\[li\]/g, '\n• ')
        .replace(/\[([^\]\n]*)\]\((?:https?:[^)\s]*)?\)?/g, '$1')
        .trim();
    }
    function normAuthor(a) {
      a = clampStr(a, 60).trim();
      if (!a) return 'Član zajednice';
      /* defense-in-depth: enforce "Ime P." even if the worker sends more */
      var parts = a.split(/\s+/);
      if (parts.length > 1) {
        var last = parts[parts.length - 1];
        var initial = last.charAt(0).toUpperCase();
        return parts.slice(0, -1).join(' ') + (initial ? ' ' + initial + '.' : '');
      }
      return a;
    }
    /* Treat every worker post as untrusted; coerce to a known-safe shape. */
    function sanitizePost(p) {
      if (!p || typeof p !== 'object') return null;
      return {
        title: clampStr(plainSkool(p.title), 140),
        content: clampStr(plainSkool(p.content), 400),
        author: normAuthor(p.author),
        avatar: safeImgUrl(p.avatar),
        image: safeImgUrl(p.image),
        upvotes: Math.max(0, parseInt(p.upvotes, 10) || 0),
        comments: Math.max(0, parseInt(p.comments, 10) || 0),
        createdAt: typeof p.createdAt === 'string' ? p.createdAt : ''
      };
    }

    var ICON_HEART = 'M8 14.2 6.8 13C3 9.6.7 7.5.7 4.9.7 2.8 2.3 1.2 4.4 1.2c1.2 0 2.4.6 3.1 1.5 1.4-.9 1.9-1.5 3.1-1.5 2.1 0 3.7 1.6 3.7 3.7 0 2.6-2.3 4.7-6.1 8.1L8 14.2z';
    var ICON_CHAT = 'M2 2h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H6l-3.6 2.7A.6.6 0 0 1 1.5 14V3a1 1 0 0 1 1-1z';
    function el(tag, cls, txt) {
      var n = doc.createElement(tag);
      if (cls) n.className = cls;
      if (txt != null) n.textContent = txt;
      return n;
    }
    function statSpan(pathD, count) {
      var s = el('span');
      /* pathD is a hard-coded constant; count is a coerced integer */
      s.innerHTML = '<svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path d="' + pathD + '"/></svg>';
      s.appendChild(doc.createTextNode(String(count)));
      return s;
    }
    function attachImgFallback(im, isCover) {
      im.addEventListener('error', function () {
        var wrap = im.closest('.win-card__img');
        if (wrap) wrap.remove(); else im.style.visibility = 'hidden';
      });
    }

    function cardEl(post, idx) {
      var art = el('article', 'win-card');
      var longTxt = post.content.length > 170;

      var head = el('div', 'win-card__head');
      if (post.avatar) {
        var ava = el('img', 'win-card__ava');
        ava.src = post.avatar; ava.alt = ''; ava.loading = 'lazy'; ava.decoding = 'async';
        ava.width = 38; ava.height = 38;
        attachImgFallback(ava);
        head.appendChild(ava);
      } else {
        var avaPh = el('span', 'win-card__ava');
        avaPh.setAttribute('aria-hidden', 'true');
        head.appendChild(avaPh);
      }
      var who = el('div', 'win-card__who');
      who.appendChild(el('div', 'win-card__name', post.author));
      who.appendChild(el('div', 'win-card__time', relTime(post.createdAt) + ' · #pobede'));
      head.appendChild(who);
      art.appendChild(head);

      if (post.title) art.appendChild(el('h3', 'win-card__title', post.title));
      if (post.content) art.appendChild(el('p', 'win-card__txt', post.content));
      if (longTxt) {
        /* toggling is handled by the delegated .win-card__more listener */
        var more = el('button', 'win-card__more', 'Prikaži još');
        more.type = 'button';
        art.appendChild(more);
      }
      if (post.image) {
        var wrap = el('div', 'win-card__img');
        var img = el('img');
        img.src = post.image; img.alt = ''; img.loading = 'lazy'; img.decoding = 'async';
        img.width = 640; img.height = 400; /* reserve space → no masonry reflow (CLS) */
        attachImgFallback(img);
        wrap.appendChild(img);
        art.appendChild(wrap);
      }

      var foot = el('div', 'win-card__foot');
      foot.appendChild(statSpan(ICON_HEART, post.upvotes));
      foot.appendChild(statSpan(ICON_CHAT, post.comments));
      art.appendChild(foot);

      return art;
    }

    function renderBatch() {
      var n = 0;
      while (buffer.length && n < batch) {
        grid.appendChild(cardEl(buffer.shift(), shown + n));
        n++;
      }
      shown += n;
      if (moreBtn) {
        var left = total - shown;
        moreBtn.hidden = !(buffer.length || shown < total);
        if (left > 0) moreBtn.textContent = 'Učitaj još pobeda (' + fmt(left) + ')';
      }
    }

    function fetchPage(cb) {
      fetch(CFG.worker + '/wins?page=' + page)
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d || !Array.isArray(d.posts)) { cb(false); return; }
          /* worker is untrusted: coerce every post to a safe shape, drop junk */
          var clean = d.posts.map(sanitizePost).filter(Boolean);
          total = Math.max(0, parseInt(d.total, 10) || clean.length);
          buffer = buffer.concat(clean);
          if (totalEl && total) {
            totalEl.textContent = '';
            var b = doc.createElement('b');
            b.textContent = fmt(total);
            totalEl.appendChild(b);
            totalEl.appendChild(doc.createTextNode(' objava u #pobede'));
          }
          if (page === 1 && clean[0] && clean[0].createdAt) {
            var fresh = qs('[data-wins-fresh]', sec);
            var rt = relTime(clean[0].createdAt);
            if (fresh && rt) {
              fresh.hidden = false;
              fresh.textContent = 'poslednja: ' + rt;
            }
          }
          page++;
          cb(true);
        })
        .catch(function () { cb(false); });
    }

    function boot() {
      /* Card images come from Skool's CDN; warm that connection while the
         feed request is in flight so the first avatars skip DNS + TLS. */
      preconnect('https://assets.skool.com');
      /* One skeleton per card in the first batch, at card-ish heights, so the
         grid reserves close to its loaded size and swapping in real cards
         barely shifts the sections below it (keeps CLS low). */
      var heights = [188, 300, 224, 400, 208, 336, 188, 264, 232, 372, 200, 288];
      for (var s = 0; s < batch; s++) {
        var sk = doc.createElement('div');
        sk.className = 'wins__skeleton';
        sk.style.height = heights[s % heights.length] + 'px';
        grid.appendChild(sk);
      }
      fetchPage(function (ok) {
        qsa('.wins__skeleton', grid).forEach(function (el) { el.remove(); });
        if (!ok) {
          sec.style.display = 'none';
          return;
        }
        renderBatch();
      });
    }
    /* The feed sits far down the page, so its fetch must never compete with
       the LCP. Two triggers, whichever fires first: the section coming
       within ~1400px of the viewport (as before), or the browser going idle
       after the load event. The payload is ~20 KB, so fetching it once the
       LCP window is over costs nothing, and on a phone – where reaching this
       section takes a while – the cards are already rendered (images still
       lazy) instead of showing skeletons that wait on the network. */
    var booted = false, bootIO = null;
    function bootOnce() {
      if (booted) return;
      booted = true;
      if (bootIO) bootIO.disconnect();
      boot();
    }
    if (DESIGN || !('IntersectionObserver' in window)) {
      bootOnce();
    } else {
      bootIO = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) bootOnce();
      }, { rootMargin: '1400px 0px' });
      bootIO.observe(sec);
      var idle = window.requestIdleCallback || function (f) { setTimeout(f, 800); };
      var afterLoad = function () { idle(bootOnce, { timeout: 4000 }); };
      if (doc.readyState === 'complete') afterLoad();
      else window.addEventListener('load', afterLoad, { once: true });
    }

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        if (busy) return;
        if (buffer.length >= batch || shown + buffer.length >= total) {
          renderBatch();
          return;
        }
        busy = true;
        moreBtn.textContent = 'Učitavam…';
        fetchPage(function () {
          busy = false;
          renderBatch();
        });
      });
    }
  }

  /* --- Loom posters + duration chips ----------------------------
     Deferred: the testimonials section is ~7 viewports down, so we
     only fetch a card's oEmbed when it nears the viewport (saves ~15
     third-party requests on first paint). Loom's default thumbnail_url
     is a ~1.3 MB animated GIF; the same path as .jpg is a ~45 KB still,
     so we rewrite the extension. Cached in localStorage for 24h. */
  var loomIO = null;
  function loomThumbJpg(url) {
    return typeof url === 'string' ? url.replace(/\.gif(\?|$)/i, '.jpg$1') : url;
  }
  function hydrateLoom(card) {
    if (card.__loomDone) return;
    card.__loomDone = true;
    var img = qs('img[data-oembed]', card);
    var bg = qs('.testi-card__bg', card);
    if (!img && !bg) return; /* hero player with a poster has its own chrome */
    var share = card.getAttribute('data-loom');
    if (!share) {
      /* hero inline player: the share URL lives on its start link */
      var st = qs('.player__start', card);
      share = st ? st.getAttribute('href') : '';
    }
    var key = 'loomv:' + share;
    var applyThumb = function (url) {
      if (!img || !url) return;
      img.src = loomThumbJpg(url);
      if (bg) bg.classList.remove('testi-card__bg--pending');
    };
    var applyDur = function (secs) {
      if (!bg || !secs || qs('.testi-card__dur', bg)) return;
      var chip = doc.createElement('span');
      chip.className = 'testi-card__dur';
      chip.textContent = Math.floor(secs / 60) + ':' + String(Math.round(secs % 60)).padStart(2, '0');
      bg.appendChild(chip);
    };
    var cached = null;
    try { cached = JSON.parse(localStorage.getItem(key)); } catch (e) {}
    if (cached && cached.exp > Date.now()) { applyThumb(cached.t); applyDur(cached.d); return; }
    fetch('https://www.loom.com/v1/oembed?url=' + encodeURIComponent(share))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d) return;
        applyThumb(d.thumbnail_url);
        applyDur(d.duration);
        try { localStorage.setItem(key, JSON.stringify({ t: loomThumbJpg(d.thumbnail_url) || '', d: d.duration || 0, exp: Date.now() + 864e5 })); } catch (e) {}
      })
      .catch(function () {});
  }
  function loomMeta(scope) {
    var cards = qsa('[data-loom], [data-inline-player]', scope);
    if (!cards.length) return;
    if (!('IntersectionObserver' in window) || DESIGN) { cards.forEach(hydrateLoom); return; }
    if (!loomIO) {
      loomIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { hydrateLoom(en.target); loomIO.unobserve(en.target); }
        });
      }, { rootMargin: '500px 0px' });
    }
    cards.forEach(function (card) {
      if (card.__loomObs) return;
      card.__loomObs = true;
      loomIO.observe(card);
    });
  }

  /* --- countdown ------------------------------------------------ */
  function countdown(scope) {
    var box = qs('[data-count-end]', scope) || (scope !== doc && scope.hasAttribute && scope.hasAttribute('data-count-end') ? scope : null);
    if (!box || box.__init) return;
    box.__init = true;
    var end = new Date(box.getAttribute('data-count-end'));
    if (isNaN(end)) { box.hidden = true; return; }
    var cells = {
      d: qs('[data-cd="d"]', box), h: qs('[data-cd="h"]', box),
      m: qs('[data-cd="m"]', box), s: qs('[data-cd="s"]', box)
    };
    var prev = {};
    function set(k, v) {
      v = String(v).padStart(2, '0');
      if (prev[k] === v) return;
      prev[k] = v;
      if (cells[k]) {
        cells[k].textContent = v;
        if (!RM) {
          cells[k].classList.remove('tick');
          void cells[k].offsetWidth;
          cells[k].classList.add('tick');
        }
      }
    }
    function tick() {
      if (!box.isConnected) return; /* section was re-rendered in the editor */
      var diff = end.getTime() - Date.now();
      if (diff <= 0) { box.hidden = true; return; }
      var t = Math.floor(diff / 1000);
      set('d', Math.floor(t / 86400));
      set('h', Math.floor(t / 3600) % 24);
      set('m', Math.floor(t / 60) % 60);
      set('s', t % 60);
      setTimeout(tick, 1000);
    }
    tick();
  }

  /* --- dinar hint, Serbia only ----------------------------------
     [data-rsd] elements stay hidden unless the request came from Serbia.
     The worker's /geo reads Cloudflare's country for THIS request (never
     cached), so a timezone or language guess is never used: outside
     Serbia the hint does not render. Cached per tab session. */
  var GEO_RS = false;
  function rsd(scope) {
    if (!GEO_RS && !DESIGN) return;
    qsa('[data-rsd]', scope).forEach(function (el) { el.hidden = false; });
  }
  function geoOnce() {
    if (DESIGN || !qsa('[data-rsd]').length) return;
    var cc = null;
    try { cc = sessionStorage.getItem('geo-cc'); } catch (e) {}
    var apply = function (code) {
      if (code !== 'RS') return;
      GEO_RS = true;
      doc.documentElement.classList.add('geo-rs');
      rsd(doc);
    };
    if (cc) { apply(cc); return; }
    if (!CFG.worker) return;
    fetch(CFG.worker + '/geo', { cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var code = d && typeof d.country === 'string' ? d.country.toUpperCase() : '';
        try { sessionStorage.setItem('geo-cc', code || 'XX'); } catch (e) {}
        apply(code);
      })
      .catch(function () {});
  }

  /* --- the app's price (CorvusPay switch) -------------------------
     With the switch on, deal-price renders the theme's „Cena" in
     [data-cena] with an empty [data-cena-rsd] beside it, and the join card
     and the offer an empty [data-cena-napomena] under the button. The app
     the join buttons go to answers /api/javno/cena with what a new buyer
     pays now (Black Friday included) and, outside Serbia, the same in the
     visitor's currency: then the local price goes first, the dinars beside
     it and the note under the button. Asked once per visit
     (sessionStorage); before it answers, or if it fails, the theme's
     „Cena" stays. The editor keeps showing the setting. Same code in
     theme.js. */
  var CENA = null;
  function cena(scope) {
    var lok = CENA && CENA.lokalna, rsd = CENA ? fmt(CENA.rsd) + ' RSD' : '', reg = bfReg();
    /* the theme's markup is kept, so bfOnce can put it back when the
       Black Friday window opens or closes and the app is asked again */
    qsa('[data-cena]', scope).forEach(function (el) {
      if (CENA) {
        if (el.__html == null) el.__html = el.innerHTML;
        el.textContent = lok ? lok.tekst : rsd;
      } else if (el.__html != null) {
        el.innerHTML = el.__html;
        el.__html = null;
      }
    });
    qsa('[data-cena-rsd]', scope).forEach(function (el) { el.textContent = lok ? '(' + rsd + ')' : ''; el.hidden = !lok; });
    qsa('[data-cena-napomena]', scope).forEach(function (el) { el.textContent = lok ? CENA.napomena || '' : ''; el.hidden = !lok; });
    /* Black Friday's struck price: abroad the regular price in the visitor's
       currency too, at the rate of the app's own answer.
       shortcut: that rate comes from a rounded amount, so it can be one unit
       off the app's conversion; read the list price from the app once
       /api/javno/cena returns it. */
    qsa('[data-cena-stara]', scope).forEach(function (el) {
      if (el.__txt == null) el.__txt = el.textContent;
      var step = lok && (lok.valuta === 'MKD' || lok.valuta === 'HUF') ? 10 : 1;
      el.textContent = lok && reg ? lok.tekst.replace(/\d[\d.]*/, fmt(Math.round(reg * lok.iznos / CENA.rsd / step) * step)) : el.__txt;
    });
  }
  function cenaOnce() {
    var a = qs('a[data-checkout]');
    if (DESIGN || !a || !qs('[data-cena]')) return;
    /* one answer per side of the Black Friday window (bfOnce asks again at its edges) */
    var bf = bfPhase() !== 'off', key = 'talas-cena' + (bf ? '-bf' : '');
    var use = function (d) {
      if (!d || typeof d.rsd !== 'number') return false;
      CENA = d;
      cena(doc);
      bfApply(doc);
      return true;
    };
    try { if (use(JSON.parse(sessionStorage.getItem(key)))) return; } catch (e) {}
    fetch(new URL('/api/javno/cena', a.href).href, { cache: 'no-cache' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if ((bfPhase() !== 'off') !== bf || !use(d)) return;
        /* the regular price inside the window is not kept: the app's own
           window may open a moment later than this browser's clock */
        if (bf && d.rsd >= bfReg()) return;
        try { sessionStorage.setItem(key, JSON.stringify(d)); } catch (e) {}
      })
      .catch(function () {});
  }

  /* --- price deadline -------------------------------------------
     body[data-deal-deadline] is the ISO deadline (23:59:59 Belgrade).
     Pages are CDN-cached, so the client decides the phase: before it,
     [data-deal="before"] shows with a live lead "Za N dana" (same rules
     as snippets/deal-lead) and the older "još N dana" count; after it,
     [data-deal="after"] shows and the top bar goes. Re-run per section
     load (editor) and once a minute. */
  function dealApply(scope) {
    var iso = doc.body.getAttribute('data-deal-deadline');
    if (!iso) return;
    var end = new Date(iso).getTime();
    if (isNaN(end)) return;
    var ms = end - Date.now();
    var after = ms < 0;
    qsa('[data-deal]', scope).forEach(function (el) {
      el.hidden = (el.getAttribute('data-deal') === 'after') !== after;
    });
    if (after) {
      var bar = qs('[data-deal-bar]');
      if (bar) {
        bar.remove();
        doc.body.classList.remove('bb-active');
        doc.documentElement.style.removeProperty('--bb-h');
        chromeTint('#f7f6f2');
      }
      return;
    }
    var txt, lead;
    if (ms < 36e5) { txt = 'ističe za manje od sat vremena'; lead = 'Za manje od sat vremena'; }
    else if (ms < 864e5) { txt = 'ističe danas u 23:59'; lead = 'Od sutra'; }
    else {
      var days = Math.ceil(ms / 864e5);
      var unit = days % 10 === 1 && days % 100 !== 11 ? 'dan' : 'dana';
      txt = 'još ' + days + ' ' + unit;
      lead = 'Za ' + days + ' ' + unit;
    }
    qsa('[data-deal-count]', scope).forEach(function (el) { el.textContent = txt; });
    qsa('[data-deal-lead]', scope).forEach(function (el) { if (el.textContent !== lead) el.textContent = lead; });
    var when = kada(iso, ms);
    qsa('[data-deal-when]', scope).forEach(function (el) { if (el.textContent !== when) el.textContent = when; });
  }
  /* "[kada]": the same calendar words as snippets/deal-when, for an end at
     the last second of a Belgrade day (iso), ms from now. Whole days left =
     calendar days to go; the weekday/date come from the ISO date itself, so
     the visitor's own time zone never shifts them. */
  function kada(iso, ms) {
    var dp = iso.slice(0, 10).split('-'), dayGap = Math.floor(ms / 864e5);
    if (ms < 36e5) return 'Za manje od sata';
    if (dayGap === 0) return 'Večeras u ponoć';
    if (dayGap === 1) return 'Sutra u ponoć';
    if (dayGap < 7) return 'U ' + ['nedelju', 'ponedeljak', 'utorak', 'sredu', 'četvrtak', 'petak', 'subotu'][new Date(Date.UTC(+dp[0], +dp[1] - 1, +dp[2])).getUTCDay()] + ' u ponoć';
    return (+dp[2]) + '.' + (+dp[1]) + '. u ponoć';
  }
  /* Browser chrome (Android address bar, older iOS Safari) carries the
     colour of whatever sits at the very top: the ink bar while it is up,
     the paper otherwise, so there is no seam between browser and page. */
  function chromeTint(color) {
    var m = qs('meta[name="theme-color"]');
    if (m) m.setAttribute('content', color);
  }
  function dealOnce() {
    if (!doc.body.getAttribute('data-deal-deadline')) return;
    var bar = qs('[data-deal-bar]');
    /* the lead can change the bar's height (wrap), so re-measure after each apply */
    var sync = function () { if (bar && bar.isConnected) doc.documentElement.style.setProperty('--bb-h', bar.offsetHeight + 'px'); };
    if (bar) {
      doc.body.classList.add('bb-active');
      window.addEventListener('resize', sync);
    }
    var tick = function () { dealApply(doc); sync(); };
    tick();
    setInterval(tick, 60000);
    dealTimer();
  }

  /* The top bar's "[odbrojavanje]": total hours, minutes, seconds
     ("36:24:22"), ticking on the second boundary. Liquid paints the first
     value; this corrects it for CDN-cached pages. At zero, dealApply flips
     the prices and removes the bar. Looks the elements up on every tick,
     so a re-rendered bar keeps counting. */
  function dealTimer() {
    var end = new Date(doc.body.getAttribute('data-deal-deadline') || '').getTime();
    if (isNaN(end) || !qs('[data-deal-timer]')) return;
    var pad = function (n) { return n < 10 ? '0' + n : String(n); };
    var tick = function () {
      var els = qsa('[data-deal-timer]');
      if (!els.length) return;
      var ms = end - Date.now();
      if (ms <= 0) { dealApply(doc); return; }
      var t = Math.floor(ms / 1000);
      var txt = pad(Math.floor(t / 3600)) + ':' + pad(Math.floor(t / 60) % 60) + ':' + pad(t % 60);
      els.forEach(function (el) { if (el.textContent !== txt) el.textContent = txt; });
      setTimeout(tick, (ms % 1000) + 20);
    };
    tick();
  }

  /* --- Black Friday ---------------------------------------------
     body[data-bf-window] = "start cyber end" (ISO, Belgrade; cyber empty
     without the extra Cyber Monday day), rendered while the sale is ahead
     or on (snippets/bf-phase). Pages are CDN-cached, so the client decides
     the phase, like dealApply: off | bf | cyber. [data-bf="on"] shows inside
     the window and [data-bf="off"] outside it, [data-bf="bf"] and
     [data-bf="cyber"] only in the week and on the extra day; [data-bf-upl]
     the same for the bank slip, by the theme's window alone (the worker
     charges by it). With the CorvusPay switch on the card's price is the
     app's: an answer at the regular price (body[data-bf-reg]) shows no sale.
     The bar comes with the window and goes at its end. Re-run per section
     load (editor) and once a minute. */
  function bfWindow() {
    var a = (doc.body.getAttribute('data-bf-window') || '').split(' ');
    var t = function (s) { return s ? new Date(s).getTime() : NaN; };
    return { start: t(a[0]), cyber: t(a[1]), end: t(a[2]), iso: a[2] || '' };
  }
  function bfPhase() {
    var w = bfWindow(), now = Date.now();
    if (isNaN(w.start) || isNaN(w.end) || now < w.start || now > w.end) return 'off';
    return now >= w.cyber ? 'cyber' : 'bf';
  }
  function bfReg() {
    return parseInt((doc.body.getAttribute('data-bf-reg') || '').replace(/\D/g, ''), 10);
  }
  function bfShow(attr, ph, scope) {
    qsa('[' + attr + ']', scope).forEach(function (el) {
      var v = el.getAttribute(attr);
      el.hidden = v === 'on' ? ph === 'off' : v !== ph;
    });
  }
  function bfApply(scope) {
    if (!doc.body.getAttribute('data-bf-window')) return;
    var w = bfWindow(), ph = bfPhase();
    bfShow('data-bf-upl', ph, scope);
    if (CENA && CENA.rsd >= bfReg()) ph = 'off';
    bfShow('data-bf', ph, scope);
    var when = kada(w.iso, w.end - Date.now());
    qsa('[data-bf-when]', scope).forEach(function (el) { if (el.textContent !== when) el.textContent = when; });
    var bar = qs('[data-bf-bar]');
    if (!bar) return;
    if (Date.now() > w.end) bar.remove();
    var on = bar.isConnected && !bar.hidden;
    doc.body.classList.toggle('bb-active', on);
    if (on) doc.documentElement.style.setProperty('--bb-h', bar.offsetHeight + 'px');
    else doc.documentElement.style.removeProperty('--bb-h');
    chromeTint(on ? '#1f1e1b' : '#f7f6f2');
  }
  function bfOnce() {
    if (!doc.body.getAttribute('data-bf-window')) return;
    var was = bfPhase() !== 'off';
    var tick = function () {
      var on = bfPhase() !== 'off';
      /* the app's price belongs to one side of the window: at an edge the
         theme's own price comes back and the app is asked again */
      if (on !== was) { was = on; CENA = null; cena(doc); cenaOnce(); }
      bfApply(doc);
    };
    tick();
    setInterval(tick, 60000);
    window.addEventListener('resize', function () {
      var bar = qs('[data-bf-bar]');
      if (bar && !bar.hidden) doc.documentElement.style.setProperty('--bb-h', bar.offsetHeight + 'px');
    });
  }

  /* --- looping clips: load near the viewport, respect reduced motion --- */
  var clipIO = null;
  function playClip(v) {
    if (v.__clip) return;
    v.__clip = true;
    v.src = v.getAttribute('data-src');
    if (RM) { v.setAttribute('controls', ''); return; }
    v.autoplay = true;
    var p = v.play();
    if (p && p.catch) p.catch(function () { v.setAttribute('controls', ''); });
  }
  function clips(scope) {
    var vids = qsa('video[data-src]', scope);
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) { vids.forEach(playClip); return; }
    if (!clipIO) {
      clipIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { playClip(en.target); clipIO.unobserve(en.target); } });
      }, { rootMargin: '600px 0px' });
    }
    vids.forEach(function (v) { if (!v.__obs) { v.__obs = true; clipIO.observe(v); } });
  }

  /* --- ticker duration ------------------------------------------ */
  function ticker(scope) {
    qsa('.tkr__row', scope).forEach(function (row) {
      if (row.__tkr) return;
      row.__tkr = true;
      var track = qs('.tkr__track', row);
      if (!track) return;
      var set = function () {
        if (!row.isConnected) return;
        var w = track.scrollWidth;
        row.style.setProperty('--tkr-dur', clamp(w / 55, 26, 90).toFixed(1) + 's');
      };
      set();
      window.addEventListener('resize', set);
    });
  }

  /* --- sticky mobile CTA ----------------------------------------
     Never on screen together with another button + price: it stays away
     while the join card under the hero, the offer, the final CTA or the
     footer is visible (the bottom 90px, where the bar itself sits, does
     not count), and in the first viewport. Re-built on every boot:
     observers are disposed and re-created so they always point at the
     CURRENT section elements. */
  function stickyCta() {
    stickyObservers.forEach(function (o) { o.disconnect(); });
    stickyObservers = [];
    var bar = qs('.sticky-cta');
    if (!bar) return;
    var hideWhenVisible = ['.hero__card', '#cena', '.final', '.foot'];
    var states = hideWhenVisible.map(function () { return false; });
    var toggle = function () {
      var b = qs('.sticky-cta');
      if (!b) return;
      var past = window.scrollY > window.innerHeight * 0.75;
      var anyVisible = states.some(function (v) { return v; });
      var on = past && !anyVisible;
      b.classList.toggle('is-on', on);
      /* phones: the chat's button comes and goes with this bar, so it never sits on a join button */
      var ta = qs('.ta-root');
      if (ta) ta.setAttribute('data-phone', on ? '1' : '0');
    };
    if ('IntersectionObserver' in window) {
      hideWhenVisible.forEach(function (sel, i) {
        var el = qs(sel);
        if (!el) return;
        var io = new IntersectionObserver(function (en) {
          states[i] = en[0].isIntersecting;
          toggle();
        }, { threshold: 0, rootMargin: '0px 0px -90px 0px' });
        io.observe(el);
        stickyObservers.push(io);
      });
    }
    if (!stickyCta.__scroll) {
      stickyCta.__scroll = true;
      window.addEventListener('scroll', toggle, { passive: true });
    }
    toggle();
  }

  /* ============================================================
     B. Document-level singletons (bind once, survive re-renders)
     ============================================================ */

  function navOnce() {
    var body = doc.body;
    var navEl = qs('#nav');
    if (!navEl) return;
    var lastY = 0, navTick = false;
    var render = function () {
      navTick = false;
      var y = window.scrollY;
      body.classList.toggle('is-scrolled', y > 24);
      if (y > 520 && y > lastY + 6 && !body.classList.contains('menu-open')) {
        navEl.classList.add('nav--hidden');
      } else if (y < lastY - 4 || y < 520) {
        navEl.classList.remove('nav--hidden');
      }
      lastY = y;
    };
    var onScroll = function () { if (!navTick) { navTick = true; raf(render); } };
    window.addEventListener('scroll', onScroll, { passive: true });
    render();

    var burger = qs('.nav__burger');
    var overlay = qs('#nav-overlay');
    var setMenu = function (open) {
      body.classList.toggle('menu-open', open);
      if (burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (overlay) overlay.setAttribute('aria-hidden', open ? 'false' : 'true');
      lockScroll('menu', open);
    };
    if (burger) {
      burger.addEventListener('click', function () {
        setMenu(!body.classList.contains('menu-open'));
      });
    }
    if (overlay) {
      qsa('a', overlay).forEach(function (a) {
        a.addEventListener('click', function () { setMenu(false); });
      });
    }
    doc.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && body.classList.contains('menu-open')) setMenu(false);
    });
  }

  /* Video modal – fully delegated so it works after any re-render.
     Only the loom video ID (hex) reaches the iframe src, so no
     attribute/scheme injection is possible from data-loom. */
  var lastFocus = null, trapModal = null;
  function trapTab(e) {
    if (e.key !== 'Tab' || !trapModal) return;
    var f = qsa('a[href], button:not([disabled]), iframe, [tabindex]:not([tabindex="-1"])', trapModal)
      .filter(function (n) { return n.offsetParent !== null || n.tagName === 'IFRAME'; });
    if (!f.length) { e.preventDefault(); return; }
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function openLoom(share, trigger) {
    var modal = qs('.vmodal');
    if (!modal) { window.open(share, '_blank', 'noopener'); return; }
    var m = (share || '').match(/loom\.com\/(?:share|embed)\/([a-f0-9]+)/i);
    if (!m) { window.open(share, '_blank', 'noopener'); return; }
    var frame = qs('.vmodal__frame', modal);
    /* The frame grows out of the tapped card and goes back into it:
       transform-origin = the card's centre in the frame's own (untransformed)
       box, start scale = card width / frame width. */
    if (trigger && trigger.getBoundingClientRect && frame.offsetWidth) {
      var tr = trigger.getBoundingClientRect();
      modal.style.setProperty('--vm-ox', (tr.left + tr.width / 2 - frame.offsetLeft).toFixed(1) + 'px');
      modal.style.setProperty('--vm-oy', (tr.top + tr.height / 2 - frame.offsetTop).toFixed(1) + 'px');
      modal.style.setProperty('--vm-s', clamp(tr.width / frame.offsetWidth, 0.25, 0.95).toFixed(3));
    }
    lastFocus = doc.activeElement;
    frame.innerHTML = '<iframe src="https://www.loom.com/embed/' + m[1] + '?autoplay=1&hide_share=true&hideEmbedTopBar=true" allow="autoplay; fullscreen" allowfullscreen title="Video"></iframe>';
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    lockScroll('modal', true);
    var main = qs('#glavni');
    if (main) main.setAttribute('inert', ''); /* background out of the a11y/tab tree */
    trapModal = modal;
    doc.addEventListener('keydown', trapTab, true);
    var c = qs('.vmodal__close', modal);
    if (c) c.focus();
  }
  function closeLoom() {
    var modal = qs('.vmodal.is-open');
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    var frame = qs('.vmodal__frame', modal);
    if (frame) frame.innerHTML = '';
    trapModal = null;
    doc.removeEventListener('keydown', trapTab, true);
    var main = qs('#glavni');
    if (main) main.removeAttribute('inert');
    lockScroll('modal', false);
    if (lastFocus && lastFocus.isConnected) lastFocus.focus();
  }

  /* --- hero inline player + theater ----------------------------
     The intro video plays INSIDE the program-monitor card: the start
     overlay swaps the poster for the Loom embed in place (fast – no
     overlay transition, poster visible until the embed paints), and
     the transport-bar corners button pins the SAME card over the
     viewport. No reparenting → playback survives the toggle. */
  function startInlinePlayer(start) {
    var player = start.closest('.player');
    var media = player && qs('.player__media', player);
    var video = media && qs('video[data-player-video]', media);
    var share = start.getAttribute('href') || start.getAttribute('data-loom-inline') || '';
    var m = share.match(/loom\.com\/(?:share|embed)\/([a-f0-9]+)/i);
    if (!media || (!video && !m)) { window.open(share, '_blank', 'noopener'); return; }
    if (player.__playing) return;
    player.__playing = true;
    player.classList.add('player--loading');
    var reveal = function () {
      if (!player.isConnected) return;
      player.classList.remove('player--loading');
      player.classList.add('is-playing');
    };
    if (video) {
      /* Self-hosted MP4/HLS (Shopify Files): plays in place with the
         browser's own controls – no third-party chrome, reactions,
         comments or sign-up prompts. The poster stays up (spinner on
         the play button) until the first frame is actually playing. */
      if (!video.__bound) {
        video.__bound = true;
        video.addEventListener('playing', reveal);
        video.addEventListener('ended', function () {
          player.classList.remove('is-playing');
          player.__playing = false;
          try { video.currentTime = 0; } catch (e) {}
        });
      }
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(reveal); /* play refused → hand over to native controls */
      setTimeout(reveal, 4000);
      if (typeof window.gtag === 'function') window.gtag('event', 'video_start', { video_title: 'uvodni', sale: window.__SALE || 'none' });
      return;
    }
    var f = doc.createElement('iframe');
    f.src = 'https://www.loom.com/embed/' + m[1] + '?autoplay=1&hide_share=true&hide_owner=true&hide_title=true&hideEmbedTopBar=true';
    f.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
    f.setAttribute('allowfullscreen', '');
    f.title = 'Uvodni video';
    f.addEventListener('load', reveal);
    setTimeout(reveal, 4000); /* belt & braces if load never fires */
    media.appendChild(f);
  }
  /* Theater (apple-design: spatial consistency + interruptibility): the
     video grows out of its card to fill the screen and shrinks back into
     the same spot, on the same critically damped spring as the CSS
     (--spring). A ghost keeps the card's slot while the player is out of
     flow, so the way back always lands where it came from. A toggle in
     mid-flight starts from the live on-screen transform, never from the
     end value, so there is no jump. Reduced motion: switches in place. */
  var SPRING = { easing: 'cubic-bezier(0.2, 0, 0, 1)', ms: 590 };
  try { if (window.CSS && CSS.supports('transition-timing-function', 'linear(0, 1)')) SPRING.easing = 'linear(0, 0.0010 0.5%, 0.0084 1.5%, 0.0285 2.8%, 0.0648 4.4%, 0.1182 6.4%, 0.1869 8.5%, 0.2674 10.9%, 0.3549 13.5%, 0.4447 16.3%, 0.5325 19.3%, 0.6148 22.4%, 0.6891 25.8%, 0.7541 29.3%, 0.8092 33.0%, 0.8547 36.8%, 0.8914 40.8%, 0.9202 45.0%, 0.9423 49.3%, 0.9590 53.8%, 0.9713 58.4%, 0.9803 63.1%, 0.9866 68.0%, 0.9910 73.0%, 0.9941 78.1%, 0.9962 83.4%, 0.9975 88.8%, 0.9984 94.3%, 1)'; } catch (e) {}
  var CLIP_FULL = 'inset(0px 0px 0px 0px round 0px 0px 0px 0px)';
  /* the picture as drawn inside the fullscreen player (object-fit: contain) */
  function theaterFrame(player) {
    var r = player.getBoundingClientRect();
    var v = qs('video', player);
    var ar = (v && v.videoWidth && v.videoHeight) ? v.videoWidth / v.videoHeight : 16 / 9;
    var w = Math.min(r.width, r.height * ar), h = w / ar;
    return { r: r, x: r.left + (r.width - w) / 2, y: r.top + (r.height - h) / 2, w: w, h: h };
  }
  /* transform + clip that make the fullscreen player look like `slot` */
  function theaterPose(player, slot) {
    var f = theaterFrame(player), r = f.r;
    var k = slot.width / f.w;
    var tx = slot.left - f.x * k, ty = slot.top - f.y * k;
    var rad = (16 / k).toFixed(2) + 'px';
    return {
      transform: 'translate(' + tx.toFixed(2) + 'px, ' + ty.toFixed(2) + 'px) scale(' + k.toFixed(4) + ')',
      clipPath: 'inset(' + (f.y - r.top).toFixed(2) + 'px ' + (r.right - f.x - f.w).toFixed(2) + 'px ' +
        (r.bottom - f.y - f.h).toFixed(2) + 'px ' + (f.x - r.left).toFixed(2) + 'px round ' + rad + ' ' + rad + ' 0px 0px)'
    };
  }
  function theaterPopover(player, on) {
    /* The desktop card is position:sticky, which is its own stacking
       context, so a plain fixed overlay stays UNDER the fixed nav and
       its close button gets covered. The top layer (Popover API) escapes
       every ancestor context without reparenting, so playback survives.
       Browsers without it keep the plain overlay. */
    if (typeof player.showPopover !== 'function') return;
    try {
      if (on) {
        player.setAttribute('popover', 'manual');
        if (!player.matches(':popover-open')) player.showPopover();
      } else {
        if (player.matches(':popover-open')) player.hidePopover();
        player.removeAttribute('popover');
      }
    } catch (e) { player.removeAttribute('popover'); }
  }
  function theaterAnimate(player, from, to, done) {
    player.style.transformOrigin = '0 0';
    var a;
    try {
      a = player.animate([from, to], { duration: SPRING.ms, easing: SPRING.easing, fill: 'forwards' });
    } catch (e) { a = null; }
    var finish = function () {
      if (player.__anim !== a) return;
      player.__anim = null;
      if (done) done();
      if (a) a.cancel();
      player.style.transformOrigin = '';
    };
    player.__anim = a;
    if (a) a.onfinish = finish; else { player.__anim = null; if (done) done(); player.style.transformOrigin = ''; }
  }
  function toggleTheater(player, force) {
    if (!player) return;
    var isOn = player.classList.contains('player--theater') && !player.__leaving;
    var on = (force === true || force === false) ? force : !isOn;
    if (on === isOn) return;
    /* interrupted mid-flight: remember where it is on screen right now */
    var live = null;
    if (player.__anim) {
      var cs = getComputedStyle(player);
      live = { transform: cs.transform, clipPath: cs.clipPath };
      var old = player.__anim;
      player.__anim = null;
      old.cancel();
    }
    var fs = qs('[data-player-fs]', player);
    if (fs) {
      fs.setAttribute('aria-pressed', on ? 'true' : 'false');
      fs.setAttribute('aria-label', on ? 'Napusti ceo ekran' : 'Preko celog ekrana');
    }
    if (on) {
      var slot = player.getBoundingClientRect();
      if (!player.classList.contains('player--theater')) {
        if (!player.__ghost) {
          var ghost = doc.createElement('div');
          ghost.className = 'player__ghost';
          ghost.setAttribute('aria-hidden', 'true');
          player.parentNode.insertBefore(ghost, player);
          player.__ghost = ghost;
        }
        player.classList.add('player--theater');
        theaterPopover(player, true);
        lockScroll('theater', true);
      }
      player.__leaving = false;
      var x = qs('[data-player-close]', player);
      if (x) x.focus({ preventScroll: true });
      if (RM) return;
      theaterAnimate(player, live || theaterPose(player, slot), { transform: 'none', clipPath: CLIP_FULL });
      return;
    }
    player.__leaving = true;
    var land = function () {
      player.__leaving = false;
      player.classList.remove('player--theater');
      theaterPopover(player, false);
      if (player.__ghost) { player.__ghost.remove(); player.__ghost = null; }
      lockScroll('theater', false);
      if (fs) fs.focus({ preventScroll: true });
    };
    if (RM || !player.__ghost) { land(); return; }
    theaterAnimate(player, live || { transform: 'none', clipPath: CLIP_FULL }, theaterPose(player, player.__ghost.getBoundingClientRect()), land);
  }

  function delegatedOnce() {
    doc.addEventListener('click', function (e) {
      var t;

      /* hero inline player: play in place, never via the modal */
      t = e.target.closest && e.target.closest('[data-loom-inline]');
      if (t) { e.preventDefault(); startInlinePlayer(t); return; }

      /* theater toggle + its close button */
      t = e.target.closest && e.target.closest('[data-player-fs]');
      if (t) { toggleTheater(t.closest('.player')); return; }
      t = e.target.closest && e.target.closest('[data-player-close]');
      if (t) { toggleTheater(t.closest('.player'), false); return; }

      /* video triggers */
      t = e.target.closest && e.target.closest('[data-loom]');
      if (t) { openLoom(t.getAttribute('data-loom'), t); return; }

      /* modal close: X button or backdrop */
      if (e.target.closest && e.target.closest('.vmodal__close')) { closeLoom(); return; }
      if (e.target.classList && e.target.classList.contains('vmodal')) { closeLoom(); return; }

      /* FAQ accordion */
      t = e.target.closest && e.target.closest('.faq-item__q');
      if (t) {
        var item = t.closest('.faq-item');
        var open = item.classList.toggle('is-open');
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
        return;
      }

      /* win-card expander (cards are JS-built, but delegate anyway) */
      t = e.target.closest && e.target.closest('.win-card__more');
      if (t) {
        var card = t.closest('.win-card');
        var o = card.classList.toggle('is-open');
        t.textContent = o ? 'Prikaži manje' : 'Prikaži još';
        return;
      }

      /* testimonials "show more" */
      t = e.target.closest && e.target.closest('[data-testi-more]');
      if (t) {
        var wrap = t.closest('.testi');
        var hidden = wrap && qs('.testi__hidden', wrap);
        if (hidden) hidden.classList.add('is-open');
        if (t.parentElement) t.parentElement.remove();
        return;
      }
    });

    doc.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      closeLoom();
      var th = qs('.player--theater');
      if (th) toggleTheater(th, false);
    });

    /* newsletter */
    doc.addEventListener('submit', function (e) {
      var form = e.target.closest && e.target.closest('.nl__form');
      if (!form) return;
      e.preventDefault();
      var input = qs('.nl__input', form);
      var msg = qs('.nl__msg', form.closest('.nl') || doc);
      var email = (input && input.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        if (msg) { msg.textContent = 'Email nije validan. Pokušaj ponovo.'; msg.className = 'nl__msg err'; }
        return;
      }
      var data = new FormData(form);
      fetch(form.action, { method: 'POST', body: data, headers: { 'Accept': 'text/html' } })
        .then(function (r) {
          if (r.redirected && r.url.indexOf('challenge') !== -1) {
            form.submit();
            return;
          }
          if (msg) { msg.textContent = 'Hvala na prijavi! Stižu saveti.'; msg.className = 'nl__msg ok'; }
          form.reset();
        })
        .catch(function () {
          if (msg) { msg.textContent = 'Nešto nije u redu. Pokušaj ponovo.'; msg.className = 'nl__msg err'; }
        });
    });

    /* GA4 conversion tracking — fire "join_click" for every click toward the
       Skool community. That is the event the Talas Pulse dashboard queries (KPI,
       funnel, per-button breakdown) and the same one theme.js fires on all
       non-homepage templates; the pre-Fable homepage sent it too. This block
       previously sent "cta_click", which nothing reads, so homepage Skool clicks
       stopped being counted. cta_location comes from the button's data-cta when
       present, else it is inferred from context so banner / segment / loyalty /
       paths / footer Skool links are counted as well — matching the old theme's
       document-level coverage. With "Plaćanje preko CorvusPay-a" on, the
       same buttons go to our checkout and carry data-checkout instead. */
    doc.addEventListener('click', function (e) {
      if (typeof window.gtag !== 'function') return;
      var a = e.target.closest && e.target.closest('a[href*="skool.com/talasakademija"], a[data-checkout]');
      if (!a) return;
      var loc = a.getAttribute('data-cta');
      if (!loc) {
        if (a.closest('[data-birthday-banner], .birthday-banner')) loc = 'birthday_banner';
        else if (a.closest('.segment')) loc = 'segment_card';
        else if (a.closest('.loyalty')) loc = 'loyalty';
        else if (a.closest('.pf-card')) loc = 'paths';
        else if (a.closest('.wins')) loc = 'wins';
        else if (a.closest('.foot')) loc = 'footer';
        else loc = 'other';
      }
      window.gtag('event', 'join_click', { cta_location: loc, sale: window.__SALE || 'none' });
    }, { passive: true });
  }

  /* --- birthday sale banner (layout-level, boots once) ---------
     Markup comes from snippets/birthday-banner.liquid while the
     "🎂 Rođendanska akcija" switch is ON. Day math runs client-side
     because rendered HTML is CDN-cached: countdown pill, auto-hide
     once the end date passes, session dismiss, and the --bb-h offset
     the body.bb-active rules use to shift the fixed nav + content. */
  function bannerOnce() {
    var banner = qs('[data-birthday-banner]');
    if (!banner) { doc.body.classList.remove('bb-active'); return; }
    var root = doc.documentElement;
    function off() {
      banner.remove();
      doc.body.classList.remove('bb-active');
      root.style.removeProperty('--bb-h');
      chromeTint('#f7f6f2');
    }

    try { if (sessionStorage.getItem('bb-dismissed')) return off(); } catch (e) {}

    var endStr = (banner.getAttribute('data-end-date') || '').trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(endStr)) {
      var p = endStr.split('-');
      var now = new Date();
      if (now > new Date(+p[0], +p[1] - 1, +p[2], 23, 59, 59, 999)) return off();
      var daysEl = qs('[data-birthday-days]', banner);
      if (daysEl) {
        var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        var days = Math.round((new Date(+p[0], +p[1] - 1, +p[2]) - today) / 86400000);
        daysEl.textContent = days <= 0
          ? 'Akcija traje još do 23:59h'
          : 'Akcija traje još ' + days + ' ' +
            (days % 10 === 1 && days % 100 !== 11 ? 'dan' : 'dana');
        daysEl.hidden = false;
      }
    }

    doc.body.classList.add('bb-active');
    var sync = function () { root.style.setProperty('--bb-h', banner.offsetHeight + 'px'); };
    sync();
    window.addEventListener('resize', sync);

    var close = qs('[data-birthday-close]', banner);
    if (close) {
      close.addEventListener('click', function () {
        off();
        try { sessionStorage.setItem('bb-dismissed', '1'); } catch (e) {}
      });
    }

    if (banner.getAttribute('data-confetti') === 'true' && !RM && !DESIGN) confettiBurst();
  }

  /* One short celebratory burst per load while the sale runs. Starts
     after boot on a pointer-events:none overlay, so it can't touch
     LCP/CLS; skipped for reduced motion and in the theme editor. */
  function confettiBurst() {
    var canvas = doc.createElement('canvas');
    canvas.className = 'confetti-canvas';
    canvas.setAttribute('aria-hidden', 'true');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = window.innerWidth * dpr;
    canvas.height = window.innerHeight * dpr;
    doc.body.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);

    var colors = ['#ffd84d', '#2e6ff2', '#e14da0', '#f59e0b', '#088347', '#f03e3e'];
    var W = window.innerWidth;
    var count = W < 700 ? 70 : 110; /* <100-ish keeps mobile at 60fps */
    var parts = [];
    for (var i = 0; i < count; i++) {
      parts.push({
        x: Math.random() * W,
        y: -30 - Math.random() * window.innerHeight * 0.25,
        w: 6 + Math.random() * 5,
        h: 9 + Math.random() * 6,
        vx: -1.2 + Math.random() * 2.4,
        vy: 2.2 + Math.random() * 3,
        rot: Math.random() * Math.PI,
        vr: -0.12 + Math.random() * 0.24,
        color: colors[i % colors.length]
      });
    }
    var DURATION = 3; /* seconds, fades out over the last one */
    var start = null;
    function tick(t) {
      if (start === null) start = t;
      var elapsed = (t - start) / 1000;
      ctx.clearRect(0, 0, W, window.innerHeight);
      ctx.globalAlpha = clamp(DURATION - elapsed, 0, 1);
      for (var i = 0; i < parts.length; i++) {
        var pt = parts[i];
        pt.x += pt.vx; pt.y += pt.vy; pt.vy += 0.05; pt.rot += pt.vr;
        ctx.save();
        ctx.translate(pt.x, pt.y);
        ctx.rotate(pt.rot);
        ctx.fillStyle = pt.color;
        ctx.fillRect(-pt.w / 2, -pt.h / 2, pt.w, pt.h);
        ctx.restore();
      }
      if (elapsed < DURATION) raf(tick); else canvas.remove();
    }
    raf(tick);
  }

  /* ============================================================
     C. Boot + theme editor wiring
     ============================================================ */
  function boot(scope) {
    scope = scope || doc;
    counters(scope);
    applyLive(scope);
    wins(scope);
    loomMeta(scope);
    countdown(scope);
    ticker(scope);
    rsd(scope);
    dealApply(scope);
    cena(scope);
    bfApply(scope);
    clips(scope);
    stickyCta();
  }

  navOnce();
  delegatedOnce();
  bannerOnce();
  dealOnce();
  bfOnce();
  boot(doc);
  fetchLive();
  geoOnce();
  cenaOnce();

  /* The customizer swaps section DOM on every tweak – re-init just
     that subtree. select/deselect need no work; reorder re-fires load. */
  doc.addEventListener('shopify:section:load', function (e) {
    boot(e.target || doc);
  });
})();
